import metadata from "../../metadata.min.json.js";
function withMetadataArgument(func, _arguments) {
  var args = Array.prototype.slice.call(_arguments);
  return args.push(metadata), func.apply(this, args);
}
export {
  withMetadataArgument as default
};
//# sourceMappingURL=withMetadataArgument.js.map
